import React, { useState } from "react";

const ToolTip = props => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleFocus = e => {
    setShowToolTip(true);
  };
  const handleBlur = e => {
    setShowToolTip(false);
  };

  const children = props.children;
  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        onFocus: handleFocus,
        onBlur: handleBlur,
      });
    }

    return child;
  });

  return (
    <div className="tooltip">
      <div className="tooltip-element">{childrenWithProps}</div>
      {showToolTip && (
        <div className="tooltip-wrapper">
          <div className="tooltip-content">
            <p dangerouslySetInnerHTML={{ __html: props.text }}></p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ToolTip;
